import { WarningOutlined } from "@ant-design/icons";
import { Flex } from "antd";
import { AxiosError } from "axios";
import React from "react";

import styles from "./ErrorView.module.scss";

import { Description } from "../Description";
import { Title } from "../Title";

interface ErrorViewProps {
    header?: string;
    message?: string;
    error?: unknown;
    showDetails?: boolean;
}

export const ErrorView: React.FC<ErrorViewProps> = ({
    header = "Oops!",
    message = "An unexpected error occurred.",
    error,
    showDetails = false
}) => {
    if (error instanceof AxiosError) {
        return <AxiosErrorView error={error} showDetails={showDetails} />;
    }

    return (
        <Flex vertical align="center" justify="center" className="error-view">
            <WarningOutlined className={styles.icon}/>
            <Title tagName="h2" className="error-title">{header}</Title>
            <Description theme="t1" className="error-description">{message}</Description>
        </Flex>
    );
};

interface AxiosErrorViewProps {
    error: AxiosError;
    showDetails?: boolean;
}

interface AxiosErrorResponseData {
    ExceptionMessage?: string;
    ErrorId?: string;
    Source?: string;
    SupportMessage?: string;
}

const AxiosErrorView: React.FC<AxiosErrorViewProps> = ({ error, showDetails }) => {
    const data = error?.response?.data as AxiosErrorResponseData | undefined;

    return (
        <Flex vertical align="center" justify="center" className="axios-error-view" gap={20}>
            <WarningOutlined className={styles.icon}/>
            <Title tagName="h3" className="error-title">{error.message}</Title>
            <Description theme="t2" className="error-description">
                URL: {error?.request?.responseURL}
            </Description>
            {showDetails && <Flex vertical align="center" className={styles.errorDetails} gap={3}>
                <Description theme="t4" className="error-description">
                    ErrorId: {data?.ErrorId}
                </Description>
                <Description theme="t2" className="error-description">
                    ExceptionMessage: {data?.ExceptionMessage}
                </Description>
                <Description theme="t4" className="error-description">
                    Source: {data?.Source}
                </Description>
                <Description theme="t4" className="error-description">
                    SupportMessage: {data?.SupportMessage}
                </Description>
            </Flex>}
            
        </Flex>
    );
};